import {
  get_EmptySerializersModuleLegacyJs2imgse4bg8t49 as get_EmptySerializersModuleLegacyJs,
  Argless3r6eomzmfocjb as Argless,
  WithTypeArguments3lgzobm0y96ba as WithTypeArguments,
  SerialModuleImplr8n4cadfc33f as SerialModuleImpl,
} from './SerializersModule.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
  captureStack1fzi4aczwc4hg as captureStack,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { isInterface150ul88kmyj8d as isInterface } from '../internal/Platform.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { asSequence2lno4vpru4ldl as asSequence } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Maps.mjs';
import { SerializersModuleCollector3dddz14wd7brg as SerializersModuleCollector } from './SerializersModuleCollector.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function EmptySerializersModule() {
  return get_EmptySerializersModuleLegacyJs();
}
var SerializersModuleBuilderClass;
function SerializersModuleBuilder() {
  if (SerializersModuleBuilderClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.hashMapOf' call
        tmp.g1l_1 = HashMap().n8();
        var tmp_0 = this;
        // Inline function 'kotlin.collections.hashMapOf' call
        tmp_0.h1l_1 = HashMap().n8();
        var tmp_1 = this;
        // Inline function 'kotlin.collections.hashMapOf' call
        tmp_1.i1l_1 = HashMap().n8();
        var tmp_2 = this;
        // Inline function 'kotlin.collections.hashMapOf' call
        tmp_2.j1l_1 = HashMap().n8();
        var tmp_3 = this;
        // Inline function 'kotlin.collections.hashMapOf' call
        tmp_3.k1l_1 = HashMap().n8();
        this.l1l_1 = false;
      }
      c1l(kClass, serializer) {
        return this.m1l(kClass, new (Argless())(serializer));
      }
      a1l(kClass, provider) {
        return this.m1l(kClass, new (WithTypeArguments())(provider));
      }
      d1l(baseClass, actualClass, actualSerializer) {
        this.n1l(baseClass, actualClass, actualSerializer);
      }
      e1l(baseClass, defaultSerializerProvider) {
        this.o1l(baseClass, defaultSerializerProvider, false);
      }
      f1l(baseClass, defaultDeserializerProvider) {
        this.p1l(baseClass, defaultDeserializerProvider, false);
      }
      q1l(forClass, provider, allowOverwrite) {
        if (!allowOverwrite) {
          var previous = this.g1l_1.p3(forClass);
          if (!(previous == null) && !equals(previous, provider)) {
            throw SerializerAlreadyRegisteredException().v1l('Contextual serializer or serializer provider for ' + toString(forClass) + ' already registered in this module');
          }
        }
        // Inline function 'kotlin.collections.set' call
        this.g1l_1.s3(forClass, provider);
        if (isInterface(forClass))
          this.l1l_1 = true;
      }
      m1l(forClass, provider, allowOverwrite, $super) {
        allowOverwrite = allowOverwrite === VOID ? false : allowOverwrite;
        var tmp;
        if ($super === VOID) {
          this.q1l(forClass, provider, allowOverwrite);
          tmp = Unit_instance;
        } else {
          tmp = $super.q1l.call(this, forClass, provider, allowOverwrite);
        }
        return tmp;
      }
      o1l(baseClass, defaultSerializerProvider, allowOverwrite) {
        var previous = this.i1l_1.p3(baseClass);
        if (!(previous == null) && !equals(previous, defaultSerializerProvider) && !allowOverwrite) {
          throw IllegalArgumentException().a1('Default serializers provider for ' + toString(baseClass) + ' is already registered: ' + toString_0(previous));
        }
        // Inline function 'kotlin.collections.set' call
        this.i1l_1.s3(baseClass, defaultSerializerProvider);
      }
      p1l(baseClass, defaultDeserializerProvider, allowOverwrite) {
        var previous = this.k1l_1.p3(baseClass);
        if (!(previous == null) && !equals(previous, defaultDeserializerProvider) && !allowOverwrite) {
          throw IllegalArgumentException().a1('Default deserializers provider for ' + toString(baseClass) + ' is already registered: ' + toString_0(previous));
        }
        // Inline function 'kotlin.collections.set' call
        this.k1l_1.s3(baseClass, defaultDeserializerProvider);
      }
      w1l(baseClass, concreteClass, concreteSerializer, allowOverwrite) {
        var name = concreteSerializer.az().h10();
        // Inline function 'kotlin.collections.getOrPut' call
        var this_0 = this.h1l_1;
        var value = this_0.p3(baseClass);
        var tmp;
        if (value == null) {
          // Inline function 'kotlin.collections.hashMapOf' call
          var answer = HashMap().n8();
          this_0.s3(baseClass, answer);
          tmp = answer;
        } else {
          tmp = value;
        }
        var baseClassSerializers = tmp;
        // Inline function 'kotlin.collections.getOrPut' call
        var this_1 = this.j1l_1;
        var value_0 = this_1.p3(baseClass);
        var tmp_0;
        if (value_0 == null) {
          // Inline function 'kotlin.collections.hashMapOf' call
          var answer_0 = HashMap().n8();
          this_1.s3(baseClass, answer_0);
          tmp_0 = answer_0;
        } else {
          tmp_0 = value_0;
        }
        var names = tmp_0;
        var previousSerializer = baseClassSerializers.p3(concreteClass);
        if (!(previousSerializer == null) && !equals(previousSerializer, concreteSerializer)) {
          if (allowOverwrite)
            names.t3(previousSerializer.az().h10());
          else
            throw SerializerAlreadyRegisteredException().x1l(baseClass, concreteClass);
        }
        var previousByName = names.p3(name);
        if (!(previousByName == null) && !equals(previousByName, concreteSerializer)) {
          // Inline function 'kotlin.sequences.find' call
          var tmp0 = asSequence(baseClassSerializers);
          var tmp$ret$7;
          $l$block: {
            // Inline function 'kotlin.sequences.firstOrNull' call
            var _iterator__ex2g4s = tmp0.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              if (element.f2() === previousByName) {
                tmp$ret$7 = element;
                break $l$block;
              }
            }
            tmp$ret$7 = null;
          }
          var tmp0_safe_receiver = tmp$ret$7;
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e2();
          var tmp_1;
          if (tmp1_elvis_lhs == null) {
            var message = 'Name ' + name + ' is registered in the module but no Kotlin class is associated with it.';
            throw IllegalStateException().o4(toString(message));
          } else {
            tmp_1 = tmp1_elvis_lhs;
          }
          var previousClass = tmp_1;
          if (allowOverwrite)
            baseClassSerializers.t3(previousClass);
          else
            throw IllegalArgumentException().a1("Multiple polymorphic serializers in a scope of '" + toString(baseClass) + "' " + ("have the same serial name '" + name + "': " + toString(concreteSerializer) + " for '" + toString(concreteClass) + "' and " + toString_0(previousByName) + " for '" + toString(previousClass) + "'"));
        }
        // Inline function 'kotlin.collections.set' call
        baseClassSerializers.s3(concreteClass, concreteSerializer);
        // Inline function 'kotlin.collections.set' call
        names.s3(name, concreteSerializer);
      }
      n1l(baseClass, concreteClass, concreteSerializer, allowOverwrite, $super) {
        allowOverwrite = allowOverwrite === VOID ? false : allowOverwrite;
        var tmp;
        if ($super === VOID) {
          this.w1l(baseClass, concreteClass, concreteSerializer, allowOverwrite);
          tmp = Unit_instance;
        } else {
          tmp = $super.w1l.call(this, baseClass, concreteClass, concreteSerializer, allowOverwrite);
        }
        return tmp;
      }
      d19() {
        return new (SerialModuleImpl())(this.g1l_1, this.h1l_1, this.i1l_1, this.j1l_1, this.k1l_1, this.l1l_1);
      }
    }
    initMetadataForClass($, 'SerializersModuleBuilder', VOID, VOID, [SerializersModuleCollector()]);
    SerializersModuleBuilderClass = $;
  }
  return SerializersModuleBuilderClass;
}
var SerializerAlreadyRegisteredExceptionClass;
function SerializerAlreadyRegisteredException() {
  if (SerializerAlreadyRegisteredExceptionClass === VOID) {
    class $ extends IllegalArgumentException() {
      static v1l(msg) {
        var $this = this.a1(msg);
        captureStack($this, $this.u1l_1);
        return $this;
      }
      static x1l(baseClass, concreteClass) {
        return this.v1l('Serializer for ' + toString(concreteClass) + ' already registered in the scope of ' + toString(baseClass));
      }
    }
    initMetadataForClass($, 'SerializerAlreadyRegisteredException');
    SerializerAlreadyRegisteredExceptionClass = $;
  }
  return SerializerAlreadyRegisteredExceptionClass;
}
//region block: exports
export {
  EmptySerializersModule as EmptySerializersModule991ju6pz9b79,
  SerializersModuleBuilder as SerializersModuleBuilderfxsfdohcdipc,
};
//endregion

//# sourceMappingURL=SerializersModuleBuilders.mjs.map
